import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "retake",
  "use": "retake-usage",
  "viewBox": "0 0 20 12",
  "content": "<symbol viewBox=\"0 0 20 12\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"retake\">\n<path d=\"M19.1875 8.46875C19.0625 8.1875 18.7812 8 18.5 8H17V3.5C17 2.125 15.875 1 14.5 1H10.5C9.9375 1 9.5 1.46875 9.5 2C9.5 2.5625 9.9375 3 10.5 3H14.5C14.75 3 15 3.25 15 3.5V8H13.5C13.1875 8 12.9062 8.15625 12.7812 8.4375C12.6875 8.71875 12.75 9.0625 12.9688 9.28125L15.4688 11.7812C15.5938 11.9375 15.7812 12 16 12C16.1875 12 16.375 11.9375 16.5 11.7812L19 9.28125C19.2188 9.09375 19.2812 8.75 19.1875 8.46875ZM9.5 9H5.5C5.21875 9 5 8.78125 5 8.5V4H6.5C6.78125 4 7.0625 3.84375 7.1875 3.5625C7.28125 3.28125 7.21875 2.9375 7 2.75L4.5 0.21875C4.375 0.09375 4.1875 0 4 0C3.78125 0 3.59375 0.09375 3.46875 0.25L0.96875 2.75C0.75 2.9375 0.6875 3.28125 0.78125 3.5625C0.90625 3.84375 1.1875 4 1.5 4H3V8.5C3 9.90625 4.09375 11 5.5 11H9.5C10.0312 11 10.5 10.5625 10.5 10C10.5 9.46875 10.0312 9 9.5 9Z\" fill=\"#26A69A\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/sharedComponents/Icon/images/retake.svg
// module id = P6l3
// module chunks = 13